export const announceVehicleStatus = (message) => {
  if (!message || typeof window === "undefined" || !("speechSynthesis" in window)) return;

  const utterance = new SpeechSynthesisUtterance(message);
  utterance.lang = "vi-VN";
  utterance.rate = 1;
  utterance.pitch = 1;
  const vietnameseVoice = window.speechSynthesis
    .getVoices()
    .find((voice) => voice.lang?.toLowerCase().startsWith("vi"));
  if (vietnameseVoice) utterance.voice = vietnameseVoice;

  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(utterance);
};
